export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      headerH: 0,
      filterH: 0,
      tHeaderH: 0,
      tFooterH: 0,
      infelicity: 0,
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowHeight = window.innerHeight;
    }
  },
  computed: {
    tableHeight() {
      const height =
        this.windowHeight -
        (this.headerH +
          this.filterH +
          this.tHeaderH +
          this.tFooterH +
          this.infelicity +
          this.offsetHeight);

      return height.toString() + 'px';
    },
  }
};
